<template lang="html">
  <!-- Remember to put &nbsp; after each period as Brad prefers two spaces instead of one before new sentence -->
  <div style="background-color: #ffffff;">
    <v-container justify-center wrap fluid class="description-container">
      <v-layout justify-center wrap>
        <v-flex xs12 sm10 md8 lg6>
          <h1 class="description-title">Join our talented team</h1>

          <v-flex mt-4>
            <p class="body-text">We are always looking for talented artists, software engineers and mathematicians. &nbsp;If you're interested in joining our team of brilliant, passionate, and skilled associates, get in touch with us today.</p>
          </v-flex>

          <v-flex mt-4>
            <p class="body-text">To be considered for any openings listed below, please apply online (available within the applicable job description).</p>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="career-email">
            <img src="../assets/Icon_Mail.svg" height="22px" />
            <p class="body-text" style="color: white; margin: 0; padding-left: 0.5rem;">Careers:</p>
            <a href="mailto:careers@blitzoo.com" target="_top" class="body-text" style="margin-left: 1rem; color: white;">careers@blitzoo.com</a>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <section class="career-text-container mt-3">
      <v-container>
        <!-- Blitzoo -->
        <v-layout row justify-center>
          <!-- <v-flex xs12 sm10 md8 lg6 xl4 justify-start class="text-xs-left font-weight-bold" :class="{ 'mt-5': firstOrder }" id="title"> -->
          <v-flex xs12 sm10 md8 lg6 xl4 justify-center class="text-xs-center font-weight-bold" id="title">
            <h3 class="career-subtitle">Current Positions Available at Blitzoo</h3>
          </v-flex>
        </v-layout>

        <v-layout row justify-center>
          <v-flex xs12 sm10 md8 lg6 xl4 justify-center>
            <div id="BDHRMobileJobListings" class="text-xs-left"></div>
          </v-flex>
        </v-layout>

        <!-- reverse order -->
        <!-- <div v-else>
          <v-layout row justify-center>
            <v-flex xs12 sm10 md8 lg6 xl4 justify-start class="text-xs-left font-weight-bold" id="title">
              <h3 class="career-subtitle">Current Positions Available at KSG Mobile</h3>
            </v-flex>
          </v-layout>

          <v-layout row justify-center>
            <v-flex xs12 sm10 md8 lg6 xl4 justify-center>
              <div id="BDHRMobileJobListings" class="text-xs-left"></div>
            </v-flex>
          </v-layout>

          <v-layout row justify-center>
            <v-flex xs12 sm10 md8 lg6 xl4 justify-start class="text-xs-left font-weight-bold mt-5" id="title">
              <h3 class="career-subtitle">Current Positions Available at King Show Games</h3>
            </v-flex>
          </v-layout>

          <v-layout row justify-center>
            <v-flex xs12 sm10 md8 lg6 xl4 justify-center>
              <div id="BDHRJobListings" class="text-xs-left"></div>
            </v-flex>
          </v-layout>
        </div> -->

      <!-- <v-flex xs12>
        <v-card id="job-board">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="jobs"
            :search="search"
            expand
            item-key="position"
            class="table-color"
          >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td class='row-text text-xs-left table-position'><strong>{{ props.item.position }}</strong></td>
              <td class='row-text text-xs-center'><strong>{{ props.item.department }}</strong></td>
              <td class='row-text text-xs-right'>{{ props.item.location }}</td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card flat color="grey lighten-3">
              <v-card-text style="width: 80%; text-align: left;">
                <h2>{{ props.item.position }}</h2>
                <hr>
                <br>
                <span v-html="props.item.description"></span>
                <span v-html="props.item.company"></span>
                <span v-html="props.item.candidate"></span>
                <span v-if="props.item.location === 'Vancouver, BC'"><p>To apply, please send resume, cover letter and completed application form to <a href="mailto:careers@ksg.com" target="_top">careers@ksg.com</a>. &nbsp;The application form can be downloaded <a :href="`${publicPath}ksg-vancouver-employment-application.pdf`" target="_blank">here</a>. &nbsp;{{ props.item.code }}</p></span>
                <span v-else><p>To apply, please send resume, cover letter and completed application form to <a href="mailto:careers@ksg.com" target="_top">careers@ksg.com</a>. &nbsp;The application form can be downloaded <a :href="`${publicPath}ksg-mn-employment-application.pdf`" target="_blank">here</a>. &nbsp;{{ props.item.code }}</p></span> -->

                <!-- This is not dynamic -->
                <!-- <p>King Show Games, Inc., a video game development company, is currently interviewing qualified applicants interested in pursuing a career in video game development. &nbsp;We are looking for people who are innovative, talented, creative, and passionate about the gaming industry. &nbsp;If you’re a self-motivated team player who is able to multi-task and can handle the following responsibilities, we look forward to hearing from you!</p>

                <h3>Job Summary</h3>
                <p>Work collaboratively with our Team to develop and maintain a robust, high performance and cost-effective infrastructure capable of supporting 1 million daily active users (at a minimum) while supporting the development needs of multiple developers in multiple locations. &nbsp;Applicants should be keen to solve problems, optimize performance and improve reliability in all aspects of our technology stack.</p>

                <h3>Responsibilities</h3>
                <ul>
                  <li>Develop and maintain a high-performance and robust production infrastructure with close to zero down time.</li>
                  <li>Develop and maintain a robust build pipeline capable of meeting the daily build requirements of engineers, producers and the quality assurance team.</li>
                  <li>Interact with the engineering team to ensure the infrastructure is structured in such a way to optimize the performance and reliability of the underlying code.</li>
                  <li>Develop and maintain appropriate monitoring tools to report against infrastructure performance.</li>
                  <li>Monitor and report against all elements of the infrastructure.</li>
                  <li>Research new technology where necessary to meet business needs.</li>
                </ul>
                <br>

                <h3>Qualifications Required</h3>
                <ul>
                  <li>BS in Computer Science or equivalent education / experience.</li>
                  <li>At least 5 years as a DevOps engineer, preferably in the business-to-consumer (B2C) gaming industry.</li>
                  <li>Experience with Amazon Web Services (EC2, ELB, Cloudfront, Cloudwatch, S3), NoSQL Databases (MongoDB), Docker, Service registration and Discovery systems (Kubernetes), Git, CICD systems (Jenkins), System performance tuning (JVM), Systems and applications monitoring (New Relic).</li>
                  <li>Experience with scripting/interpreted languages such as BASH, PERL, Go, Javascript, Python or Ruby are an asset.</li>
                  <li>Candidates must be highly responsive and be willing to respond to operational issues promptly, both inside and outside of office hours.</li>
                  <li>Candidates must have excellent organizational skills, good oral and written communications skills, and a high level of interpersonal skills.</li>
                  <li>Must be a self-motivated team player with the ability to work in a customer oriented, very fast-paced, and demanding environment.</li>
                  <li>Ability to bring projects to completion with minimal supervision.</li>
                  <li>Must be able to meet or exceed set project milestones and deadlines, which will entail extra work time as needed (work hours beyond a normal work week).</li>
                </ul>
                <br>

                <h3>Bonus Attributes</h3>
                <ul>
                  <li>Experience with Google Cloud, Bigquery, Data Studio and DeltaDNA.</li>
                  <li>Experience with NoSQL (MongoDB preferred).</li>
                  <li>Familiarity with iOS, Android, or Facebook app marketplaces.</li>
                </ul>

                <br>
                <p>This job description should not be interpreted as all-inclusive; it is intended to identify major responsibilities and requirements of the job. &nbsp;Team members may be requested to perform other job-related tasks and responsibilities other than those stated above.</p>

                <h3>About King Show Games</h3>
                <p>Founded in 1998, King Show Games is a Minnesota based company providing entertaining video games that are played around the world. &nbsp;Our growing company consists of talented artists, engineers, mathematicians and producers that have created over 200 games.</p>

                <p>Our Company Belief consists of 4 principals:</p>
                <ul>
                  <li><strong>THINK BIG</strong> – Think outside the box; strive to be successful.</li>
                  <li><strong>BE FRANK</strong> – Be open and sincere in your dealings with others; be forthright.</li>
                  <li><strong>FIGHT HARD</strong> – Believe in your ideas; speak up for your convictions.</li>
                  <li>After the call, <strong>MOVE AS A TEAM!</strong></li>
                </ul>
                <br>

                <p>King Show Games offers competitive salaries and a full range of comprehensive benefits including a bonus plan, medical, dental, life and long-term disability insurance</p>
                <p>King Show Games is an equal opportunity employer.</p>
                <hr>

                <p>Candidates only apply. &nbsp;Recruiters please don't contact King Show Games.<br>
                  Please, no phone calls about this job! <br>
                  Please do not contact King Show Games about other services, products or commercial interests.
                </p>
                <p>To apply, please send resume and cover letter to <a href="mailto:careers@ksg.com" style="color: hotpink" target="_top">careers@ksg.com</a>.</p> -->
              <!-- </v-card-text>
            </v-card>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
    <div></div> -->
    </v-container>
  </section>
</div>
</template>

<script>
import { bdhr } from '../components/utils/ccp_widget_support.js'
export default {
  name: 'Career',
  data () {
    return {
      publicPath: process.env.BASE_URL,
      search: '',
      headers: [
        { text: 'Position', value: 'position', align: 'left' },
        { text: 'Department', value: 'department', align: 'center' },
        { text: 'Location', value: 'location', align: 'right' }
      ],
      jobs: [
        {
          position: 'Lead DevOps Engineer (Mtka)',
          department: 'Infrastructure & Operations',
          location: 'Minnetonka, MN',
          description: '<p>King Show Games, Inc., a video game development company, is currently interviewing qualified applicants interested in pursuing a career in video game development. &nbsp;We are looking for people who are innovative, talented, creative, and passionate about the gaming industry. &nbsp;If you’re a self-motivated team player who is able to multi-task and can handle the following responsibilities, we look forward to hearing from you!</p><h3>Job Summary</h3><p>Work collaboratively with our Team to develop and maintain a robust, high performance and cost-effective infrastructure capable of supporting 1 million daily active users (at a minimum) while supporting the development needs of multiple developers in multiple locations. &nbsp;Applicants should be keen to solve problems, optimize performance and improve reliability in all aspects of our technology stack.</p><h3>Responsibilities</h3><ul><li>Develop and maintain a high-performance and robust production infrastructure with close to zero down time.</li><li>Develop and maintain a robust build pipeline capable of meeting the daily build requirements of engineers, producers and the quality assurance team.</li><li>Interact with the engineering team to ensure the infrastructure is structured in such a way to optimize the performance and reliability of the underlying code.</li><li>Develop and maintain appropriate monitoring tools to report against infrastructure performance.</li><li>Monitor and report against all elements of the infrastructure.</li><li>Research new technology where necessary to meet business needs.</li></ul><br><h3>Qualifications Required</h3><ul><li>BS in Computer Science or equivalent education / experience.</li><li>At least 5 years as a DevOps engineer, preferably in the business-to-consumer (B2C) gaming industry.</li><li>Experience with Amazon Web Services (EC2, ELB, Cloudfront, Cloudwatch, S3), NoSQL Databases (MongoDB), Docker, Service registration and Discovery systems (Kubernetes), Git, CICD systems (Jenkins), System performance tuning (JVM), Systems and applications monitoring (New Relic).</li><li>Experience with scripting/interpreted languages such as BASH, PERL, Go, Javascript, Python or Ruby are an asset.</li><li>Candidates must be highly responsive and be willing to respond to operational issues promptly, both inside and outside of office hours.</li><li>Candidates must have excellent organizational skills, good oral and written communications skills, and a high level of interpersonal skills.</li><li>Must be a self-motivated team player with the ability to work in a customer oriented, very fast-paced, and demanding environment.</li><li>Ability to bring projects to completion with minimal supervision.</li><li>Must be able to meet or exceed set project milestones and deadlines, which will entail extra work time as needed (work hours beyond a normal work week).</li></ul><br><p>While this role requires the ability to manage Live Operations, we are associate/family friendly and recognize the importance of work/life balance.</p><p>This job description should not be interpreted as all-inclusive; it is intended to identify major responsibilities and requirements of the job. &nbsp;Team members may be requested to perform other job-related tasks and responsibilities other than those stated above.</p>',
          company: '<h3>About King Show Games</h3><p>Founded in 1998, King Show Games is a Minnesota based company providing entertaining video games that are played around the world. &nbsp;Our growing company consists of talented artists, engineers, mathematicians and producers that have created over 200 games. &nbsp;Our Company Belief consists of 4 principals:</p><ul><li><strong>THINK BIG</strong> – Think outside the box; strive to be successful.</li><li><strong>BE FRANK</strong> – Be open and sincere in your dealings with others; be forthright.</li><li><strong>FIGHT HARD</strong> – Believe in your ideas; speak up for your convictions.</li><li>After the call, <strong>MOVE AS A TEAM!</strong></li></ul><br><p>King Show Games offers competitive salaries and a full range of comprehensive benefits including a bonus plan, medical, dental, life and long-term disability insurance, as well as a matching 401k.</p><p>King Show Games is an equal opportunity employer.</p><hr>',
          candidate: "<p>Candidates only apply. &nbsp;Recruiters please don't contact King Show Games. &nbsp;<br>Please, no phone calls about this job! <br>Please do not contact King Show Games about other services, products or commercial interests.</p>",
          code: ''
        }
        // {
        //   position: 'Back-end Developer (Scala / Java)',
        //   department: 'Engineering',
        //   location: 'Minnetonka, MN',
        //   description: '<p>King Show Games, a video game development company, is currently interviewing qualified applicants who are passionate about and interested in pursuing a career in video game development. &nbsp;We are looking for people who are innovative, talented, creative, and passionate about the gaming industry. &nbsp;If you’re a self-motivated team player who is able to multi-task and can handle the following responsibilities, we look forward to hearing from you!</p><h3>Job Summary</h3><p>Work collaboratively with our Engineering Team to help us build a new technology stack to support a best in class social casino across multiple platforms (desktop, mobile, tablet). &nbsp;Applicants should be keen to solve problems, optimize performance, and improve reliability in all aspects of our technology stack and processes.</p><h3>Responsibilities</h3><ul><li>All aspects of back-end server programming systems including design and analysis, coding, testing, debugging, deployment and maintenance</li><li>Interact with and program relational and NoSQL database systems</li><li>Develop efficient code and scalable database structures in order to support high server request volumes</li><li>Develop and maintain continuous integration build pipelines to bridge the gap between code and final deployment</li><li>Gather scope and objectives from design and client requirements</li><li>Research new technology where necessary to meet business needs</li></ul><br><h3>Qualifications Required</h3><ul><li>BS in Computer Science or equivalent education / experience</li><li>At least 2 years’ experience developing back-end server systems</li><li>Experience developing in Scala and/or Java (Scala preferred)</li><li>Experience working with MongoDB and/or MySQL (Mongo preferred)</li><li>Basic knowledge of common web development languages (e.g. JavaScript, CSS, HTML, JQuery, Ajax)</li><li>Basic knowledge of and experience working with Linux based systems</li><li>Candidates must have excellent organizational skills, good oral and written communications skills, and a high level of interpersonal skills.</li><li>Must be a self-motivated team player with the ability to work in a customer oriented, very fast-paced, and demanding environment.</li><li>Ability to bring projects to completion with minimal supervision.</li><li>Must be able to meet or exceed set project milestones and deadlines, which will entail extra work time as needed (work hours beyond a normal work week).</li></ul><br><h3>Bonus Attributes</h3><ul><li>Experience working with Play Framework, AKKA</li><li>Experience with AWS, Git, Docker, Jenkins, Angular.js</li><li>Experience working in social gaming environment for mobile and desktop</li><li>Shipped at least 1 or more games on mobile and / or Facebook</li></ul><br><p>This job description should not be interpreted as all-inclusive; it is intended to identify major responsibilities and requirements of the job. &nbsp;Team members may be requested to perform other job-related tasks and responsibilities other than those stated above.</p>',
        //   company: '<h3>About King Show Games</h3><p>Founded in 1998, King Show Games is a Minnesota based company providing entertaining video games that are played around the world. &nbsp;Our growing company consists of talented artists, engineers, mathematicians and producers that have created over 200 games. &nbsp;Our Company Belief consists of 4 principals:</p><ul><li><strong>THINK BIG</strong> – Think outside the box; strive to be successful.</li><li><strong>BE FRANK</strong> – Be open and sincere in your dealings with others; be forthright.</li><li><strong>FIGHT HARD</strong> – Believe in your ideas; speak up for your convictions.</li><li>After the call, <strong>MOVE AS A TEAM!</strong></li></ul><br><p>King Show Games offers competitive salaries and a full range of comprehensive benefits including a bonus plan, medical, dental, life and long term disability insurance, as well as matching 401k.</p><p>King Show Games is an equal opportunity employer.</p><hr>',
        //   candidate: "<p>Candidates only apply. &nbsp;Recruiters please don't contact King Show Games. &nbsp;<br>Local candidates only apply. <br>Please, no phone calls about this job! <br>Please do not contact King Show Games about other services, products or commercial interests.</p>",
        //   code: 'In the Subject Line, please list Job Code: MTKA001.'
        // }
        // {
        //   position: 'Junior Data Analyst',
        //   department: 'Business Intelligence',
        //   location: 'Vancouver, BC',
        //   description: '<p>King Show Games, Inc., a video game development company, is currently interviewing qualified applicants interested in pursuing a career in video game development. &nbsp;We are looking for people who are innovative, talented, creative, and passionate about the gaming industry. &nbsp;If you’re a self-motivated team player who is able to multi-task and can handle the following responsibilities, we look forward to hearing from you!</p><h3>Job Summary</h3><p>The successful candidate will be an integral part of achieving data-driven decision making across all organizational functions. &nbsp;This person will report directly to the Data Analyst and will be responsible for supporting the Data Analyst in all areas of analysis and reporting.</p><h3>Responsibilities</h3><ul><li>Work closely with the Data Analyst to help provide the required analysis to drive decision-making.</li><li>Generate actionable reports and recommendations to support decision-making.</li><li>Develop and evolve key performance indicators across all product platforms (desktop, mobile, tablet) and all business functions.</li><li>Work closely with the Product and Engineering Team to configure, test and troubleshoot new feature development to ensure the appropriate analytics events are being captured.</li><li>Assist with the setup of automated marketing campaigns to target specific segments of users at specific times during the customer lifecycle.</li></ul><br><h3>Qualifications Required</h3><ul><li>BS in Mathematics, Information Management, Statistics or Economics (BS in Computer Science a plus).</li><li>At least 1 year of experience in a data-analytics role (preferably in an online business).</li><li>Strong SQL skills (MySQL preferred).</li><li>Advanced mathematical and statistical skills.</li><li>Proven ability to conceive and test theories; comfortable doing so by querying large and diverse data sets - can prove / disprove theories and opinions with data, analytics and dashboards.</li><li>Strong intellectual curiosity and ability to structure and solve difficult problems.</li><li>Familiarity with data analytics methodologies (or trends).</li><li>Candidates must have excellent organizational, communications (oral and written) and interpersonal skills.</li><li>Must be a self-motivated team player with the ability to work in a customer oriented, very fast-paced, and demanding environment.</li><li>Ability to bring projects to completion with minimal supervision.</li><li>Must be able to meet or exceed set project milestones and deadlines, which will entail extra work time as needed (work hours beyond a normal work week).</li></ul><br><h3>Bonus Attributes</h3><ul><li>Experience with Google Cloud, Bigquery, Data Studio and DeltaDNA.</li><li>Experience with NoSQL (MongoDB preferred).</li><li>Familiarity with iOS, Android, or Facebook app marketplaces.</li></ul><br><p>This job description should not be interpreted as all-inclusive; it is intended to identify major responsibilities and requirements of the job. &nbsp;Team members may be requested to perform other job-related tasks and responsibilities other than those stated above.</p>',
        //   company: '<h3>About King Show Games</h3><p>Founded in 1998, King Show Games is a Minnesota based company providing entertaining video games that are played around the world. &nbsp;Our growing company consists of talented artists, engineers, mathematicians and producers that have created over 200 games.</p><p>Our Company Belief consists of 4 principals:</p><ul><li><strong>THINK BIG</strong> – Think outside the box; strive to be successful.</li><li><strong>BE FRANK</strong> – Be open and sincere in your dealings with others; be forthright.</li><li><strong>FIGHT HARD</strong> – Believe in your ideas; speak up for your convictions.</li><li>After the call, <strong>MOVE AS A TEAM!</strong></li></ul><br><p>King Show Games offers competitive salaries and a full range of comprehensive benefits including a bonus plan, medical, dental, life and long-term disability insurance.</p><p>King Show Games is an equal opportunity employer.</p><hr>',
        //   candidate: "<p>Candidates only apply. &nbsp;Recruiters please don't contact King Show Games.<br>Please, no phone calls about this job! <br>Please do not contact King Show Games about other services, products or commercial interests.</p>"
        // }
      ],
      firstOrder: true
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1
    }
  },
  methods: {
    carouselLeftClick () {
      if (this.currentCard === 0) {
        this.currentCard = this.employees.length - 1
      } else {
        this.currentCard -= 1
      }
    },
    carouselRightClick () {
      if (this.currentCard === this.employees.length - 1) {
        this.currentCard = 0
      } else {
        this.currentCard += 1
      }
    }
  },
  created () {
    let mobileOptions = {
      CCPCode: 'Blitzoo',
      ElementID: 'BDHRMobileJobListings',
      ShowCustomContent: false
    }
    bdhr.generateListing(mobileOptions)
  //   for re-ordering to put sections with contents at top
  //   setTimeout(() => {
  //     const incContents = document.getElementById('BDHRJobListings').innerHTML.includes('jobSection')
  //     const mobileContents = document.getElementById('BDHRMobileJobListings').innerHTML.includes('jobSection')
  //     if (!incContents) {
  //       if (mobileContents) {
  //         this.firstOrder = false
  //         let options = {
  //           CCPCode: 'King Show Games',
  //           ElementID: 'BDHRJobListings',
  //           ShowCustomContent: true
  //         }
  //         bdhr.generateListing(options)
  //
  //         let mobileOptions = {
  //           CCPCode: 'KSG Mobile',
  //           ElementID: 'BDHRMobileJobListings',
  //           ShowCustomContent: true
  //         }
  //         bdhr.generateListing(mobileOptions)
  //       }
  //     }
  //   }, 300)
  // },
  // mounted () {
  //   Array.from(document.querySelectorAll('[role="columnheader"]')).forEach(function (el) {
  //     el.style.color = '#335091'
  //     // el.style.fontSize = '16px'
  //   })
  }
}
</script>

<style lang="scss" scoped>
// #career-container {
//   display: grid;
//   width: 55vw;
//   place-self: center;
// }
.description-container {
  background-image: url('../assets/careers/Header_Careers.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

.description-title {
  font-family: 'open-sans-extrabold', serif;
  font-weight: 700;
  font-size: 50px;
  letter-spacing: -2px;
  line-height: 1.15;
}

.career-container {
  background-color: rgba(246, 130, 31, 0.2);
}

.career-title {
  font-family: museo-slab, serif;
  // font-style: italic;
  font-weight: 700;
  font-size: 30px;
  color: #f6821f;
  letter-spacing: -2px;
}

.career-subtitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  color: #12013a;
  display: inline-block;
  // margin-left: 0.5rem;
}

.career-subtitle-updated {
  font-family: museo-slab, serif;
  display: inline-block;
  margin-left: 0.5rem;
}

.body-text {
  font-size: 18px;
}

.career-email {
  display: flex;
}

.email-style {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  color: #5677c3;
  text-decoration: none;
  font-size: 18px;
}

.table-position {
  font-family: lato, serif;
  font-style: normal;
  font-weight: 500;
  // font-size: 18px;
  color: #f6821f;
}

#title {
  margin-bottom: 2rem;
}

#job-board {
}

// .employee-container {
//   display: grid;
//   grid-template-columns: 40% 1fr;
//   grid-gap: 1rem;
// }
//
// .employee-quotes {
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
// }
//
// .quote-style {
//   line-height: 1.15;
//   margin: 0 1rem;
// }
//
// .name-color {
//   color: #335091;
//   margin: 0 1rem;
// }
//
// .role-color {
//   color: #5677c3 !important;
//   font-size: 15px;
// }
//
// .carousel-container {
//   display: flex;
//   align-items: center;
//   padding: 0;
// }
//
// #carouselLeft:hover, #carouselRight:hover {
//   color: rgba(0,0,0,0.3)
// }
//
// .lastContainer {
//   display: grid;
//   grid-template-columns: 60% 40%;
//   margin-top: 1rem;
//   grid-gap: 2rem;
// }
//
// .mobileLastContainer {
//   display: grid;
//   grid-template-columns: 40% 60%;
//   align-items: end;
// }
//
// #workTitle {
//   font-family: museo-slab, serif;
//   font-style: normal;
//   font-weight: 800;
//   font-size: 4rem;
//   color: #335091;
//   display: inline-block;
//   line-height: 90%;
//   margin-bottom: 2rem;
// }
//
// #mobileWorkTitle {
//   font-family: museo-slab, serif;
//   font-style: normal;
//   font-weight: 800;
//   font-size: 2.9rem;
//   color: #335091;
//   display: inline-block;
//   line-height: 100%;
//   margin-bottom: 1rem;
// }
//
// .carouselDirection {
//   z-index: 10;
//   position: absolute;
//   margin-left: -1rem;
//   // top: 50%;
//   left: 0;
//   opacity: 0.4;
// }
//
// .carouselDirection:hover {
//   opacity: 1;
// }
//
// .carouselDirectionRight {
//   z-index: 10;
//   position: absolute;
//   margin-right: -1rem;
//   right: 0;
//   opacity: 0.4;
// }
//
// .carouselDirectionRight:hover {
//   opacity: 1;
// }
//
// .mobileLearnMore {
//   margin: 0;
// }
</style>
